<template>
  <Enroll :path="'/entrain'"></Enroll>
</template>

<script>
  import Enroll from '@/page/modules/enroll/detail'
  export default {
    components: { Enroll },
    data () {
      return {
      }
    }
  }
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/page/entrain/enroll/detail.vue